module.exports = __webpack_public_path__ + "media/images/emblems/Les_Planchettes-coat_of_arms-461ee17346185edb3644f2a48b49feee.svg";